// src\v2\services\enumApiService.js
import { domain, token } from "../../components/Security";
import axios from "../../api/apiClient";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const enumApiService = {
  getMaintenanceTypes: async () => {
    const response = await axios.get(`${domain}/api/enums/dropdown-types`, { headers });
    return response.data;
  },
  getApproverMaintenanceTypes: async () => {
    const response = await axios.get(`${domain}/api/enums/approver-maintenance-types`, { headers });
    return response.data;
  },
  getTaxTreatments: async () => {
    const response = await axios.get(`${domain}/api/enums/tax-treatments`, { headers });
    return response.data;
  },
  getSalaryAdvanceTypes: async () => {
    const response = await axios.get(`${domain}/api/enums/salary-advance-types`, { headers });
    return response.data;
  },
  getMaintenanceData: async (typeIds = []) => {
    if (!typeIds.length) return {};

    // Manually construct query string to match .NET List<int> expectations: 
    // ?types=2&types=6
    const params = new URLSearchParams();
    typeIds.forEach(id => params.append('types', id));

    const response = await axios.get(`${domain}/api/enums/maintenance-data?${params.toString()}`, { headers });
    return response.data;
  },
}